/** One short message after a save, e.g. «Вне рабочего времени» (D-48). */
import { useEffect, useState } from 'react';

let push: ((text: string) => void) | null = null;

export function toast(text: string): void {
  push?.(text);
}

export function ToastHost() {
  const [text, setText] = useState<string | null>(null);
  useEffect(() => {
    push = (t) => setText(t);
    return () => {
      push = null;
    };
  }, []);
  useEffect(() => {
    if (!text) return;
    const id = setTimeout(() => setText(null), 3500);
    return () => clearTimeout(id);
  }, [text]);
  return text ? (
    <div className="toast" role="status">
      {text}
    </div>
  ) : null;
}
